import { KeyboardArrowDownOutlined, KeyboardArrowUpOutlined } from '@mui/icons-material';
import { alpha, Box, Card, CardActionArea, CardContent, Collapse, Divider, Typography } from '@mui/material';
import React from 'react';
import theme from 'src/shared/components/styles/theme';

export const EventFeeCollapsible = ({
  title,
  subtitle,
  icon,
  selected,
  onSelect,
  children,
}: {
  title: string;
  subtitle: string;
  icon: React.ReactNode;
  selected: boolean;
  onSelect: () => void;
  children?: React.ReactNode;
}) => {
  return (
    <Card
      variant='outlined'
      className={selected ? 'selected' : undefined}
      sx={{
        mb: 2,
        '&.selected': {
          borderWidth: 2,
          borderColor: theme.palette.primary.main,
        },
        transition: (t) => t.transitions.create(['border-color', 'background-color', 'box-shadow'], { duration: 200 }),
      }}
    >
      <CardActionArea
        onClick={onSelect}
        className={selected ? 'selected' : undefined}
        sx={{
          p: 2,
          '&:hover': {
            backgroundColor: alpha(theme.palette.primary.light, 0.2),
          },
        }}
        aria-pressed={selected}
      >
        <Box display='flex' alignItems='center' gap={1} position='relative'>
          <Box sx={{ color: selected ? 'primary.main' : 'text.secondary' }}>{icon}</Box>
          <Box flex={1}>
            <Typography fontWeight={600} textTransform='uppercase'>
              {title}
            </Typography>
            <Typography variant='body2' color='text.secondary'>
              {subtitle}
            </Typography>
          </Box>
          {selected ? <KeyboardArrowUpOutlined sx={{ fontSize: 28 }} /> : <KeyboardArrowDownOutlined sx={{ fontSize: 28 }} />}
        </Box>
      </CardActionArea>

      {/* Innehåll i samma border */}
      <Collapse in={selected} timeout={220} unmountOnExit>
        <Divider />
        <CardContent sx={{ pt: 2 }}>{children}</CardContent>
      </Collapse>
    </Card>
  );
};
